import React from 'react'
import { Link } from 'react-router-dom'

import { LinkButton } from '../../core/components/sections'
import { formatDateFromNow } from '../../core/utils'

import {
  EXCLUSION_STATUS,
  USER_ASSIGNMENT_ACTION_TYPE,
} from '../../common/constants'

import BrandCurationTaskDeleteButton from '../components/sections/brand-curation-task-delete-button'
import BrandCurationTaskUserAssignment from '../components/sections/brand-curation-task-user-assignment'
import { BRAND_CURATION_TASK_STATUS } from '../constants'

const createBrandCurationTaskTableColumns = isDeleteButtonVisible => [
  {
    title: 'ID',
    render: ({ id }) => (
      <Link target="_blank" to={id}>
        {id}
      </Link>
    ),
  },
  {
    title: 'Brand',
    render: ({ id, brand }) => (
      <Link target="_blank" to={id}>
        {brand?.name}
      </Link>
    ),
  },
  {
    title: 'Locations',
    dataIndex: 'brand',
    render: ({ locationCount }) => locationCount,
  },
  {
    title: 'Assigned curator',
    render: ({ id, assignedCurator, assignedQc }) => (
      <BrandCurationTaskUserAssignment
        brandCurationTaskId={id}
        userActionType={USER_ASSIGNMENT_ACTION_TYPE.CURATION}
        assignedUser={assignedCurator}
        otherAssignedUsers={[assignedQc?.id]}
      />
    ),
  },
  {
    title: 'Assigned qa',
    render: ({ id, assignedQa, assignedQc }) => (
      <BrandCurationTaskUserAssignment
        brandCurationTaskId={id}
        userActionType={USER_ASSIGNMENT_ACTION_TYPE.QA}
        assignedUser={assignedQa}
        otherAssignedUsers={[assignedQc?.id]}
      />
    ),
  },
  {
    title: 'Assigned qc',
    render: ({ id, assignedQc, assignedQa, assignedCurator }) => (
      <BrandCurationTaskUserAssignment
        brandCurationTaskId={id}
        userActionType={USER_ASSIGNMENT_ACTION_TYPE.QC}
        assignedUser={assignedQc}
        otherAssignedUsers={[assignedCurator?.id, assignedQa?.id]}
      />
    ),
  },
  {
    title: 'Status',
    render: ({ taskStatus, isReopenedManually }) =>
      `${BRAND_CURATION_TASK_STATUS[taskStatus]?.label}${
        taskStatus === BRAND_CURATION_TASK_STATUS.REOPENED.value &&
        isReopenedManually
          ? ' (Manually)'
          : ''
      }`,
  },
  {
    title: 'AutoEat Status',
    dataIndex: 'brand',
    render: ({ status }) => EXCLUSION_STATUS[status].label,
  },
  {
    title: 'Website',
    dataIndex: 'brand',
    render: ({ website }) => website && <LinkButton link={website} />,
  },
  {
    title: 'Updated',
    dataIndex: 'updatedAt',
    render: date => date && formatDateFromNow(date),
  },
  {
    title: 'Added',
    dataIndex: 'createdAt',
    render: date => date && formatDateFromNow(date),
  },
  {
    title: 'Autoeat Id',
    dataIndex: 'brand',
    render: ({ autoeatId }) => autoeatId,
  },
  ...(!isDeleteButtonVisible
    ? []
    : [
        {
          title: 'Actions',
          render: ({ brand }) => {
            if (!brand.isFake) {
              return null
            }

            return <BrandCurationTaskDeleteButton brandId={brand.id} />
          },
        },
      ]),
]

export default createBrandCurationTaskTableColumns
